interface Props {
  // amount in cents
  amount: number;
  // ISO currency code
  currency?: string;
}

export function Price({ amount, currency }: Props) {
  return (
    <span>
      {getCurrencySymbol(currency)}
      {(amount / 100).toFixed(2)}
    </span>
  );
}

function getCurrencySymbol(currency?: string) {
  if (!currency) return '';
  if (currency === 'USD') return '$';
  return currency;
}
